// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.countries', {
        url: '/countries?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/countries/countries.tpl.html',
            controller: 'CountriesController as vm'
        }},
        resolve: {
            countries: countriesResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function countriesResolver(CountriesApiService, $stateParams) {
    return CountriesApiService.getCountries({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function CountriesController($rootScope, $state, $scope, countries, CountriesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.countries = countries;
    vm.selectedCountryId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.countryId; }, function(newValue, oldValue) {
            vm.selectedCountryId = parseInt($state.params.countryId,10);
        });
        $rootScope.$on('Country.Inserted', function(event, response) {
        });
        $rootScope.$on('Country.Updated', function(event, response) {
        });
        $rootScope.$on('Country.Deleted', function(event, response) {
        });
        $rootScope.$on('Country.Changed', function(event, response) {
            loadCountries();
        });
    }

    function loadCountries() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        CountriesApiService.getCountries(request).then(function(response) {
            vm.countries = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadCountries();
    }

}

angular
    .module('base.countries', ['countries.api','countries.country'])
    .config(stateConfig)
    .controller('CountriesController', CountriesController);
